<template>
  <div :class="['lp-media', { 'lp-media--contain': contain, 'lp-media--empty': !source }]">
    <img v-if="source" :src="source" :alt="alt" :width="width" :height="height" :loading="eager ? 'eager' : 'lazy'" :fetchpriority="eager ? 'high' : 'auto'" decoding="async" @error="failed" />
    <span v-else class="lp-media-fallback" role="img" :aria-label="$t('publicSite.imageUnavailable')"><UiIcon name="box" /><span>{{ $t('publicSite.imageUnavailable') }}</span></span>
  </div>
</template>
<script>
import UiIcon from '@/components/ui/UiIcon.vue';
import { safeWebUrl } from './content';
export default {
  name: 'PublicMedia', components: { UiIcon },
  props: { src: { type: String, default: '' }, alt: { type: String, default: '' }, fallback: { type: String, default: '' }, eager: Boolean, contain: Boolean, width: { type: Number, default: 960 }, height: { type: Number, default: 720 } },
  data: () => ({ failure: 0 }), computed: { source() { return this.failure === 0 ? safeWebUrl(this.src) || safeWebUrl(this.fallback) : this.failure === 1 ? safeWebUrl(this.fallback) : ''; } },
  watch: { src() { this.failure = 0; } },
  methods: { failed() { this.failure = this.source === this.fallback ? 2 : this.failure + 1; } }
};
</script>
